/* src/app/modules/shared/components/column/column-asset/column-asset.component.scss */
app-column-asset {
  display: contents;
}
/*# sourceMappingURL=column-asset.component.css.map */
